module.exports = __webpack_public_path__ + "img/logo.1ef5b73b.png";